import type { TermsOfUseDto } from "./model";
import { customInstanceBpm } from "../axios-client";

export interface PublishTermsOfUseInput {
  name: string;
  file: File;
}

export function buildTermsOfUseFormData({
  name,
  file,
}: PublishTermsOfUseInput) {
  const formData = new FormData();
  formData.append("termName", name.trim());
  formData.append("file", file);
  return formData;
}

export function publishGlobalTermsOfUse(input: PublishTermsOfUseInput) {
  return customInstanceBpm<TermsOfUseDto>("/v1/terms", {
    method: "POST",
    body: buildTermsOfUseFormData(input),
  });
}
